import React from 'react';
import Arrow from './Defs/Arrow';
import { Context } from './Context';
import RadialTidyTree from './RadialTidyTree';

class Graph extends React.Component {
  render() {
    const { width, height } = this.context;
    const { anchors } = this.props;

    return (
      <svg width={width} height={height}>
        <defs>
          <Arrow />
          <Arrow flip />
        </defs>
        <RadialTidyTree
          bundleKey={this.props.bundleKey}
          anchors={anchors}
          enabled={this.props.enabled}
          handleHover={this.props.handleHover}
        />
      </svg>
    );
  }
}

Graph.contextType = Context;

export default Graph;
